





import { Component, Prop, Vue } from "vue-property-decorator";

import { DropDownItem } from "@share/common/drop-down/types";
import { timezonesList } from "@common/data/timezones";

import SingleSelectS01 from "@share/common/form/form-controls/select/variations/single-select-s01/SingleSelect-S01.vue";

@Component({ components: { SingleSelectS01 } })

export default class AgendaFIlterTZ extends Vue {
    @Prop() value: string;

    list: DropDownItem[] = timezonesList;
}

